'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('userTaskListTable', function (userTaskService, $dialogBox, $sce) {
  return {
    restrict: 'E',
    replace: true,
    template: function template($attrs) {
      // TODO: attr to add or not the sizeable-component.
      return "\n                <div>\n                    <tl-loader-overlay ng-if=\"$ctrl.disableActions\"></tl-loader-overlay>\n                    <tl-table table-config=\"$ctrl.tableConfig\"></tl-table>\n                </div>\n            ";
    },
    scope: {
      taskType: '@'
    },
    controllerAs: '$ctrl',
    link: function link($scope, $el, $attrs, $ctrl) {
      $ctrl.initialize();
    },
    controller: function controller($scope) {
      var ctrl = this;
      ctrl.initialize = function () {
        ctrl.disableActions = false;
        userTaskService.loadTasksIfRequired();
        $scope.$watch(userTaskService.getCurrentTasks, function (currentTasks) {
          var taskType = $scope.taskType;
          if (taskType) {
            currentTasks = _.filter(currentTasks, {
              type: taskType
            });
          }
          ctrl.tasks = currentTasks;
        });
        ctrl.tableConfig = createTableConfig();
      };
      ctrl.startDownload = function (taskId) {
        userTaskService.startReportDownload(taskId);
      };
      ctrl.deleteReport = function (reportId) {
        if (ctrl.disableActions) return;
        $dialogBox.confirm({
          title: "Suppression du rapport",
          text: "Voulez vous vraiment supprimer le rapport ? Il se sera plus disponible au téléchargement."
        }).then(function () {
          ctrl.disableActions = true;
          userTaskService.deleteTask(reportId).finally(function () {
            ctrl.disableActions = false;
          });
        });
      };
      ctrl.deleteTask = function (taskId) {
        if (ctrl.disableActions) return;
        ctrl.disableActions = true;
        userTaskService.deleteTask(taskId).finally(function () {
          ctrl.disableActions = false;
        });
      };
      ctrl.killTask = function (taskId) {
        if (ctrl.disableActions) return;
        ctrl.disableActions = true;
        userTaskService.killTask(taskId).finally(function () {
          ctrl.disableActions = false;
        });
      };
      ctrl.showTextGeneration = function (taskId) {
        userTaskService.getTextGeneration(taskId).then(function (result) {
          var res = result.data;
          if (res.html) {
            $dialogBox.alert({
              title: "Résultat",
              html: $sce.trustAsHtml(res.resultat),
              width: 1000
            });
          } else {
            $dialogBox.alert({
              title: "Résultat",
              text: res.resultat,
              width: 1000
            });
          }
        });
      };
      var createTableConfig = function createTableConfig() {
        return {
          id: "userTaskListPopinTable",
          source: "$ctrl.tasks",
          height: 400,
          sortable: true,
          initialSort: ["creationDate", "desc"],
          columns: [{
            attribute: "label",
            title: "Libellé"
          }, {
            title: "Date de création",
            attribute: "creationDate",
            filter: "dateMedium",
            cellClass: 'align-c',
            width: "130px",
            sortType: 'date',
            sortable: true
          }, {
            title: "Dernière actualisation",
            attribute: "lastUpdateDate",
            filter: "dateMedium",
            cellClass: 'align-c',
            width: "130px",
            sortType: 'date',
            sortable: true
          }, {
            attribute: "status",
            title: "Status",
            width: "100px",
            filter: "translateLov:'userTaskStatus'",
            sortable: true
          }, {
            attribute: "progression",
            title: "Progression",
            filter: "percentage",
            cellClass: 'align-c',
            sortable: true
          }, {
            attribute: "message",
            title: "Message"
          }, {
            title: "Actions",
            template: "\n                           <div ng-if=\"model.result != null && model.result.type === 'FILE_GENERATION' \">\n                               <tl-icon-button icon=\"fa-download\" title=\"T\xE9l\xE9charger\" ng-click=\"$ctrl.startDownload(model.id)\"></tl-icon-button>\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteReport(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.result != null && model.result.type === 'TEXT_GENERATION' \">\n                               <tl-icon-button icon=\"fa-eye\" title=\"Afficher\" ng-click=\"$ctrl.showTextGeneration(model.id)\"></tl-icon-button>\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteReport(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.status == 'ERROR' \">\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteTask(model.id)\"></tl-icon-button>\n                           </div>\n                           <div ng-if=\"model.result==null && model.completionDate!=null\">\n                               <tl-icon-button icon=\"delete\" ng-show=\"!$ctrl.disableActions\" tl-tooltip=\"Supprimer\" ng-click=\"$ctrl.deleteTask(model.id)\"></tl-icon-button>\n                           </div>\n                                <div ng-if=\"model.killable && model.status!=='COMPLETED' && model.status!=='ERROR' && model.result==null && model.completionDate==null\">\n                               <tl-icon-button icon=\"fa-bomb\" ng-show=\"!$ctrl.disableActions\" title=\"Arr\xEAter\" ng-click=\"$ctrl.killTask(model.id)\"></tl-icon-button>\n                           </div>\n                      \n                        "
          }]
        };
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/user-task/userTaskListTable.js
// module id = 2883
// module chunks = 13